define(['jquery', 'core/notification'], function($, notification) {
    var accountSettings = {
        dom: {
            main: null,
            personalInfoForm: null,
            profilePictureForm: null,
            changePasswordForm: null,
            paymentForm: null,
            socialForm: null,
            languageForm: null,
        },
        url: {

        },
        variable: {
            validImageExtensions: ['image/png', 'image/jpg', 'image/jpeg']
        },
        langs: {

        },
        action: {
            clearNotification: function() {
                accountSettings.dom.userNotification.html('');
            },
            clickedTabLinks: function(e) {
                e = $(e.currentTarget);
                accountSettings.dom.tabs.find('.tablinks').each(function(index, item) {
                    item = $(item);
                    item.removeClass("active");
                });
                accountSettings.dom.main.find('.tabcontent').each(function(index, item) {
                    item = $(item);
                    item.css({'display': 'none'});
                });
                e.addClass("active");
                accountSettings.dom.main.find('#' + e.data('type')).css({'display': 'block'});
            },
            validatePersonalInfoForm: function(e) {
                var error = false,
                    message = '';
                if (accountSettings.dom.firstName.val().trim().length == 0) {
                    error = true;
                    message = "First Name cannot be empty.";
                } else if (accountSettings.dom.lastName.val().trim().length == 0) {
                    error = true;
                    message = "Last Name cannot be empty.";
                } else if (accountSettings.dom.phone.val().trim().length != 10 ||
                    !$.isNumeric(accountSettings.dom.phone.val())) {
                    error = true;
                    message = "Invalid Mobile number. Please enter 10 digit mobile number.";
                }
                if (error) {
                    e.preventDefault();
                    accountSettings.action.clearNotification();
                    notification.addNotification({
                        type: 'error',
                        message: message
                    });
                } else {
                    console.log('Submittion of form');
                }
            },
            validateProfilePictureForm: function(e) {
                var error = false,
                    message = "";
                if (accountSettings.dom.profilePictureFile[0].files.length == 0) {
                    error = true;
                    message = "Please upload some image.";
                } else if (accountSettings.variable.validImageExtensions
                    .includes(accountSettings.dom.profilePictureFile[0].files[0].type) == false) {
                    error = true;
                    message = "File is more than 2 MB or Please upload profile pic in the mentioned format PNG;JPG;JPEG";
                }
                if (error) {
                    e.preventDefault();
                    accountSettings.action.clearNotification();
                    notification.addNotification({
                        type: 'error',
                        message: message
                    });
                } else {
                    console.log('Profile picture Submittion');
                }
            },
            validateChangePasswordForm: function(e) {
                var error = false,
                    message = "";
                if (accountSettings.dom.oldPassword.val().length < 8) {
                    error = true;
                    message = "Old Password Should have Minimum 8 characters";
                } else if (accountSettings.dom.newPassword.val().length < 8) {
                    error = true;
                    message = "New Password Should have Minimum 8 Characters";
                } else if (accountSettings.dom.newPassword.val() !== accountSettings.dom.confirmPassword.val()) {
                    error = true;
                    message = "New Password and Confirm Password Should be same";
                } else if (accountSettings.dom.oldPassword.val() === accountSettings.dom.newPassword.val()) {
                    error = true;
                    message = "Old Password and New Password cannot be same.";
                }
                if (error) {
                    e.preventDefault();
                    accountSettings.action.clearNotification();
                    notification.addNotification({
                        type: 'error',
                        message: message
                    });
                } else {
                    console.log('update social media');
                }
            },
            validateSocialMediaForm: function(e) {
                var error = false,
                    message = "";
                if (accountSettings.dom.linkedin.val().length != 0 &&
                    !accountSettings.dom.linkedin.val().startsWith('https://www.linkedin.com/in/')) {
                    error = true;
                    message = "Invalid Linkedin URL. It should be like https://www.linkedin.com/in/your_id";
                } else if (accountSettings.dom.linkedin.val().length != 0 &&
                    accountSettings.dom.linkedin.val() === 'https://www.linkedin.com/in/') {
                    error = true;
                    message = "Invalid Linkedin URL. It should be like https://www.linkedin.com/in/your_id";
                } else if (accountSettings.dom.facebook.val().length != 0 &&
                    !accountSettings.dom.facebook.val().startsWith('https://www.facebook.com/')) {
                    error = true;
                    message = "Invalid Facebook URL. It should be like https://www.facebook.com/your_id";
                } else if (accountSettings.dom.facebook.val().length != 0 &&
                    accountSettings.dom.facebook.val() === 'https://www.facebook.com/') {
                    error = true;
                    message = "Invalid Facebook URL. It should be like https://www.facebook.com/your_id";
                } else if (accountSettings.dom.twitter.val().length != 0 &&
                    !accountSettings.dom.twitter.val().startsWith('https://twitter.com/')) {
                    error = true;
                    message = "Invalid Twitter URL. It should be like https://twitter.com/your_id";
                } else if (accountSettings.dom.twitter.val().length != 0 &&
                    accountSettings.dom.twitter.val() === 'https://twitter.com/') {
                    error = true;
                    message = "Invalid Twitter URL. It should be like https://twitter.com/your_id";
                } else if (accountSettings.dom.instagram.val().length != 0 &&
                    !accountSettings.dom.instagram.val().startsWith('https://www.instagram.com/')) {
                    error = true;
                    message = "Invalid Instagram URL. It should be like https://www.instagram.com/your_id";
                } else if (accountSettings.dom.instagram.val().length != 0 &&
                    accountSettings.dom.instagram.val() === 'https://www.instagram.com/') {
                    error = true;
                    message = "Invalid Instagram URL. It should be like https://www.instagram.com/your_id";
                }
                if (error) {
                    e.preventDefault();
                    accountSettings.action.clearNotification();
                    notification.addNotification({
                        type: 'error',
                        message: message
                    });
                } else {
                    console.log('updating social media');
                }
            }
        },
        init: function() {
            accountSettings.dom.main = $(document).find('.main');
            accountSettings.dom.tabs = accountSettings.dom.main.find('.tab');
            accountSettings.dom.userNotification = $(document).find('#user-notifications');
            // List of All Forms.
            accountSettings.dom.personalInfoForm = accountSettings.dom.main.find('#Personal_Infoform');
            accountSettings.dom.profilePictureForm = accountSettings.dom.main.find('#PhotoForm');
            accountSettings.dom.changePasswordForm = accountSettings.dom.main.find('#PasswordForm');
            accountSettings.dom.paymentForm = accountSettings.dom.main.find('#PaymentForm');
            accountSettings.dom.socialForm = accountSettings.dom.main.find('#LinkedForm');
            accountSettings.dom.languageForm = accountSettings.dom.main.find('#LanguageForm');

            // PersonalInfoForm elements.
            accountSettings.dom.firstName = accountSettings.dom.personalInfoForm.find('.firstname');
            accountSettings.dom.lastName = accountSettings.dom.personalInfoForm.find('.lastname');
            accountSettings.dom.phone = accountSettings.dom.personalInfoForm.find('.phone');

            // ProfilePictureForm Elements.
            accountSettings.dom.profilePictureFile = accountSettings.dom.profilePictureForm.find('.upload_file');
            accountSettings.dom.profilePictureFormSubmitButton = accountSettings.dom.profilePictureForm.find('button[type="submit"]');

            // PasswordForm Elements.
            accountSettings.dom.oldPassword = accountSettings.dom.changePasswordForm.find('#old_password');
            accountSettings.dom.newPassword = accountSettings.dom.changePasswordForm.find('#new_password');
            accountSettings.dom.confirmPassword = accountSettings.dom.changePasswordForm.find('#confirm_password');

            // SocialForm Elements.
            accountSettings.dom.linkedin = accountSettings.dom.socialForm.find('.linkedin');
            accountSettings.dom.facebook = accountSettings.dom.socialForm.find('.facebook');
            accountSettings.dom.twitter = accountSettings.dom.socialForm.find('.twitter');
            accountSettings.dom.instagram = accountSettings.dom.socialForm.find('.instagram');


            // Events.
            accountSettings.dom.personalInfoForm.on('submit', accountSettings.action.validatePersonalInfoForm);
            accountSettings.dom.profilePictureForm.on('submit', accountSettings.action.validateProfilePictureForm);
            accountSettings.dom.changePasswordForm.on('submit', accountSettings.action.validateChangePasswordForm);
            accountSettings.dom.changePasswordForm.on('click', '.toggle-password-btn', function(e) {
                e = $(e.currentTarget).parents('.input-group');
                if (e.find('input').attr('type') == "text") {
                    // Hide.
                    e.find('input').attr('type', 'password');
                    e.find('button').attr('title', 'Show Password');
                    e.find('.fa').toggleClass('fa-eye fa-eye-slash');
                } else {
                    // Show
                    e.find('input').attr('type', 'text');
                    e.find('button').attr('title', 'Hide Password');
                    e.find('.fa').toggleClass('fa-eye fa-eye-slash');
                }
            });
            accountSettings.dom.socialForm.on('submit', accountSettings.action.validateSocialMediaForm);

            accountSettings.dom.oldPassword.on('drop paste', function(e) {
                return false;
            });
            accountSettings.dom.newPassword.on('drop paste', function(e) {
                return false;
            });
            accountSettings.dom.confirmPassword.on('drop paste', function(e) {
                return false;
            });
            accountSettings.dom.tabs.on('click', '.tablinks', accountSettings.action.clickedTabLinks);
            var btnUpload = $("#upload_file"),
                btnOuter = $(".button_outer");
            btnUpload.on("change", function(e) {
                var ext = btnUpload.val().split('.').pop().toLowerCase();
                var mS_totalBytes = $("#upload_file")[0].files[0].size;
                if ($.inArray(ext, ['png', 'jpg', 'jpeg']) == -1) {
                    $(".error_msg").text("Uploaded profile pic is in wrong format. Please upload profile pic in the mentioned format PNG;JPG;JPEG");
                } else if (mS_totalBytes > 2097152) {
                    $(".error_msg").text("File is more than 2 MB. Please upload the file that is less than 2MB");
                } else {
                    $(".error_msg").text("");
                    btnOuter.addClass("file_uploading");
                    setTimeout(function() {
                        btnOuter.addClass("file_uploaded");
                    }, 3000);
                    var uploadedFile = URL.createObjectURL(e.target.files[0]);
                    setTimeout(function() {
                        $("#uploaded_view").append('<img src="' + uploadedFile + '" />').addClass("show");
                        accountSettings.dom.profilePictureFormSubmitButton.attr('disabled', false);
                    }, 3500);
                }
            });
            $(".file_remove").on("click", function(e) {
                $("#uploaded_view").removeClass("show");
                $("#uploaded_view").find("img").remove();
                accountSettings.dom.profilePictureFile.val('');
                btnOuter.removeClass("file_uploading");
                btnOuter.removeClass("file_uploaded");
            });
        }
    };
    return {
        init: accountSettings.init
    };
});